/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Plans_Lifetime_NameInputs */

const en_pricing_plans_lifetime_name = /** @type {(inputs: Pricing_Plans_Lifetime_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lifetime`)
};

const es_pricing_plans_lifetime_name = /** @type {(inputs: Pricing_Plans_Lifetime_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De por vida`)
};

/**
* | output |
* | --- |
* | "Lifetime" |
*
* @param {Pricing_Plans_Lifetime_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_plans_lifetime_name = /** @type {((inputs?: Pricing_Plans_Lifetime_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Plans_Lifetime_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_plans_lifetime_name(inputs)
	return es_pricing_plans_lifetime_name(inputs)
});